"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@athena-portal/core");
var FontAwesomeIcon_1 = require("./FontAwesomeIcon");
var SideMenuItem_1 = require("./SideMenuItem");
var Section_1 = require("./Section");
var MenuUtils_1 = require("./utils/MenuUtils");
var dist_1 = require("@athena-portal/core/dist");
var SideMenu = /** @class */ (function (_super) {
    __extends(SideMenu, _super);
    function SideMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            menus: _this.loadMenus(),
            expanded: false
        };
        _this.menuManager.on(dist_1.MenuEvent.Change, function () {
            _this.setState({
                menus: _this.loadMenus()
            });
        });
        _this.toggleSidebar = _this.toggleSidebar.bind(_this);
        _this.closeSidebar = _this.closeSidebar.bind(_this);
        return _this;
    }
    SideMenu.prototype.render = function () {
        var _this = this;
        var expanded = this.state.expanded;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sidebar ".concat(expanded && "expanded") },
                React.createElement("div", { className: "header" }, expanded ?
                    this.renderHeaderExpanded() :
                    this.renderHeaderCollapsed()),
                React.createElement("ul", { className: "list-group list-group-flush" }, this.state.menus.map(function (menu) {
                    return React.createElement(SideMenuItem_1.default, __assign({}, menu, { key: menu.id, level: 1, onClick: _this.closeSidebar }));
                }))),
            expanded &&
                React.createElement("div", { className: "sidebar-backdrop", onClick: this.closeSidebar })));
    };
    SideMenu.prototype.loadMenus = function () {
        return MenuUtils_1.MenuUtils.order(this.menuManager.getMenus());
    };
    /**
     * Toggles sidebar for menu item
     * @id: Id of the element
     */
    SideMenu.prototype.toggleSidebar = function () {
        this.setState({
            expanded: !this.state.expanded
        });
    };
    SideMenu.prototype.closeSidebar = function () {
        this.setState({
            expanded: false
        });
    };
    SideMenu.prototype.renderHeaderCollapsed = function () {
        return (React.createElement("a", { href: "#", onClick: this.toggleSidebar, className: "unlink" },
            React.createElement(FontAwesomeIcon_1.default, { icon: "bars" })));
    };
    SideMenu.prototype.renderHeaderExpanded = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { href: "#", onClick: this.toggleSidebar, className: "unlink float-right" },
                React.createElement(FontAwesomeIcon_1.default, { icon: "times" })),
            React.createElement(Section_1.default, { id: "logo" })));
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.MenuManager),
        __metadata("design:type", Object)
    ], SideMenu.prototype, "menuManager", void 0);
    return SideMenu;
}(React.Component));
exports.default = SideMenu;
//# sourceMappingURL=SideMenu.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/SideMenu.js
// module id = 2122
// module chunks = 0